import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

loadConfig().then(() => {});

export async function getReferences(params?: {
  query?: string;
  perPage?: number;
  pageNo?: number;
  sortBy?: string;
  sortOrder?: string;
}) {
  const queryParams = new URLSearchParams();
  if (params?.query) queryParams.append('query', params.query);
  if (params?.perPage !== undefined) queryParams.append('perPage', params.perPage.toString());
  if (params?.pageNo !== undefined) queryParams.append('pageNo', params.pageNo.toString());
  if (params?.sortBy && String(params.sortBy).trim()) queryParams.append('sortBy', params.sortBy.trim());
  if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
  const url = `${BASE_URL}/control-references/regtech${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  try {
    const response = await authService.apiCall(url, { method: 'GET' });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}


export async function getStandards() {
  try {
      
     
      const response = await authService.apiCall(`${BASE_URL}/control-references`, {
          method: "GET",
       
      });

    

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}



export async function getReport(standard: any, domain: any, subDomain: any, institution: any, complianceStatus: any, date: any) {
  try {

    try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/report?standard=${standard}&domain=${domain}&subDomain=${subDomain}&institution=${institution}&complianceStatus=${complianceStatus}&date=${date}`, {
      method: 'GET',
    
    });

      if (!response.ok) {
        throw new Error('Failed to get report');
      }
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching report:', error);
      throw new Error('Error fetching report');
    }
  }

    catch (error) {
      console.error('Error fetching users tasks:', error);
      throw new Error('Error fetching users tasks');
    }
  
}



/** Same auth/semantics as regtech list but id/name/code only — faster for dropdowns (no domain tree). */
export async function getReferencesForSelect(params?: {
  query?: string;

  perPage?: number;
  pageNo?: number;
  sortBy?: string;
  sortOrder?: string;
}) {
  const queryParams = new URLSearchParams();
  if (params?.query) queryParams.append('query', params.query);
  if (params?.perPage !== undefined) queryParams.append('perPage', params.perPage.toString());
  if (params?.pageNo !== undefined) queryParams.append('pageNo', params.pageNo.toString());
  if (params?.sortBy && String(params.sortBy).trim()) queryParams.append('sortBy', params.sortBy.trim());
  if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
  const url = `${BASE_URL}/control-references/regtech/select${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  try {
    const response = await authService.apiCall(url, { method: 'GET' });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

// Framework support (COSO/COBIT/NIST/ISO/CBE) removed 2026-05-11. These stubs
// keep the existing imports compiling while returning empty data — see
// docs/review/05_frontend_followup.md for the page-level UI surgery still owed.
export async function getCoso() { return { data: [] }; }
export async function getCobit() { return { data: [] }; }
export async function getCBE() { return { data: [] }; }



// Update basic control fields (name, description, objective, type)
export async function createControlBasic(
  controlId: string | number,
  payload: { name?: string; description?: string; objective?: string; type?: string }
): Promise<any> {
  try {
  
    const response = await authService.apiCall(`${BASE_URL}/controls/basic`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      if (response.status === 401 || response.status === 403 || (data && data.message === 'Forbidden access')) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error('Failed to update control basic info');
    }

    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update control basic info');
  }
}

export async function updateStandards(id: any, title: string) {
  try {
     
     let controlReferenceData={ name: title } 
      const response = await authService.apiCall(`${BASE_URL}/control-references/${id}`, {
          method: "PATCH",
      
          body: JSON.stringify(controlReferenceData),
      });
      return response.json();
  } catch (error) {
      throw new Error('Failed to update standards');
  }
}

// Framework stubs (see header comment near getCoso).
export async function getNIST() { return { data: [] }; }
export async function getISO() { return { data: [] }; }
export async function getControlByCBE(_id: any) { return { data: [] }; }
export async function getControlByISO(_id: any) { return { data: [] }; }
export async function getControlByCobit(_id: any) { return { data: [] }; }
export async function getControlByCoso(_id: any) { return { data: [] }; }
export async function getControlByNist(_id: any) { return { data: [] }; }

export async function uploadExcel(file: File) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await authService.apiCall(`${BASE_URL}/domain/upload-template`, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) throw new Error('Failed to upload file');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to upload file');
  }
}

export async function createDomain(domainData: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain`, {
      method: 'POST',
      body: JSON.stringify(domainData),
    });
    if (!response.ok) throw new Error('Failed to create domain');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to create domain');
  }
}

export async function updateDomain(id: string, domainData: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(domainData),
    });
    if (!response.ok) throw new Error('Failed to update domain');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update domain');
  }
}

export async function deleteDomain(id: string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete domain');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete domain');
  }
}

export async function getAllDomains() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/domain/getAll`, { method: 'GET' });
    if (!response.ok) throw new Error('Failed to fetch domains');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch domains');
  }
}

export async function fetchOneControlApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchAllDataApiCoso(): Promise<any> { return { data: [] }; }
export async function fetchAllDataApiNist(): Promise<any> { return { data: [] }; }

export async function fetchDataApiRefrence(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchDataApiRisk(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function getControl(controlId: string): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/${controlId}`, {
      method: 'GET',
    });
    if (!response.ok) throw new Error('Failed to fetch data');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch data');
  }
}

export async function updateControlApi(id: any, data: any): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/controls/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to update control');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update control');
  }
}

export async function updateControlBasic(
  controlId: string | number,
  payload: { name?: string; description?: string; objective?: string; type?: string }
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/controls/update-basic/${controlId}`,
      { method: 'PATCH', body: JSON.stringify(payload) }
    );
    const data = await response.json();
    if (!response.ok || (data && data.success === false)) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        (data && data.message === 'Forbidden access')
      ) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error('Failed to update control basic info');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update control basic info');
  }
}

export async function fetchAllDataApiJopTitle(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/jobTitles/getAll`, { method: 'GET' });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchAllDataApiSystem(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/systems/getAll`, { method: 'GET' });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchAllDataApiProcess(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/processes/getAll`, { method: 'GET' });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchAllDataApiAssertion(): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/assertion`, { method: 'GET' });
    if (!response.ok) throw new Error('Failed to fetch data');
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to fetch data');
  }
}

export async function fetchAllDataApiCobit(): Promise<any> { return { data: [] }; }
export async function fetchAllDataApiIso(): Promise<any> { return { data: [] }; }

export async function createAssertionFromControlApi(body: any): Promise<void> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/assertion/fromControl`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to create");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to create");
  }
}

export async function createStandard(payload: { name: string; description?: string; functions?: string[] }) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-references`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || 'Failed to create standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to create standard');
  }
}

export async function updateStandard(
  id: string,
  payload: { name?: string; description?: string; functions?: string[] }
) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-references/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || 'Failed to update standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to update standard');
  }
}

export async function deleteStandard(id: string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/control-references/${id}`, {
      method: 'DELETE',
    });
    const data = await response.json();
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || 'Failed to delete standard');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete standard');
  }
}
